/* Bell's Cookies: add one promotional 6-cookie box for twelve qualifying cookies.
 * Shopify's discounts determine the price. This script does not change prices
 * or remove the gift if the discount does not apply.
 */
(function () {
  'use strict';

  const node = document.getElementById('bells-gift-config');
  if (!node) return;

  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.variantId || !config.available) return;

  const sixHandles = new Set([
    'black-cocoa-crinkle-x6',
    'double-chocolate-protein-x6',
    'chocolate-chunk-x6',
    'smores-x6',
    'red-velvet-x6',
    'colombian-corn-x6',
    'vegan-chocolate-x6',
    'the-bells-x6',
    'snickerdoodle-x6',
    'coconut-almond-pandan-x6',
    'ethiopian-coffee-honey-brown-butter-crunch-x6',
    'triple-peanut-butter'
  ]);
  const twelveHandles = new Set(['chocoholics-dream-1', 'the-whole-shebang']);
  const marker = '_Bells Promo Gift';
  const markerValue = 'Free Box of 6 Assorted';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let pending = null;
  let timer = null;
  let rerunRequested = false;

  async function request(path, options) {
    const response = await fetch(root + path, options);
    const data = await response.json();
    if (!response.ok || data.status === 422) {
      throw new Error(data.description || 'Cart request failed');
    }
    return data;
  }

  function sections() {
    try {
      return window.Alpine && Alpine.store('xCartHelper')
        // Shopify accepts no more than five sections per cart mutation.
        ? Alpine.store('xCartHelper').getSectionsToRender()
          .filter(section => !section.id.endsWith('cart-upsell'))
          .slice(0, 5).map(section => section.id)
        : [];
    } catch (_) { return []; }
  }

  async function waitForThemeCart() {
    // Eurus can dispatch a cart event while its own add request is still running.
    const until = Date.now() + 3000;
    while (window.updatingCart && Date.now() < until) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  }

  async function refresh(data) {
    try {
      const helper = window.Alpine && Alpine.store('xCartHelper');
      if (helper && data.sections) {
        await helper.reRenderSections(data.sections);
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) helper.currentItemCount = parseInt(bubble.textContent, 10) || 0;
      } else if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      }
    } catch (_) {
      if (/\/cart\/?$/.test(window.location.pathname)) {
        window.location.reload();
      }
    }
  }

  function isOurGift(item) {
    return String(item.variant_id) === String(config.variantId) &&
      item.properties && item.properties[marker] === markerValue;
  }

  function qualifyingCount(cart) {
    let count = 0;
    cart.items.forEach(item => {
      if (isOurGift(item) || (item.properties && item.properties['_Gift for Pack'])) return;
      const qty = Number(item.quantity) || 0;
      if (sixHandles.has(item.handle)) count += qty * 6;
      else if (twelveHandles.has(item.handle)) count += qty * 12;
      else if (item.properties && item.properties['_Pack ID'] &&
        /^(6|12) products$/.test(String(item.properties['_Pack Size'] || ''))) count += qty;
    });
    return count;
  }

  async function run() {
    const cart = await request('cart.js', { headers: { Accept: 'application/json' } });
    if (qualifyingCount(cart) < 12) return;
    // Respect an existing box, including one the customer added themselves.
    if (cart.items.some(item => Number(item.product_id) === Number(config.productId))) return;

    const selected = sections();
    const payload = {
      items: [{ id: Number(config.variantId), quantity: 1,
        properties: { [marker]: markerValue } }]
    };
    if (selected.length) {
      payload.sections = selected;
      payload.sections_url = window.location.pathname;
    }
    const added = await request('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
    await refresh(added);
  }

  function sync() {
    if (pending) {
      rerunRequested = true;
      return pending;
    }
    pending = (async () => {
      do {
        rerunRequested = false;
        await waitForThemeCart();
        await run();
      } while (rerunRequested);
    })().finally(() => { pending = null; });
    return pending;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(() => { sync().catch(() => {}); }, 250);
  }

  window.BellsPromoGift = { sync: sync };
  document.addEventListener('eurus:cart:items-changed', schedule);
  document.addEventListener('eurus:product:added', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
